import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { proposalApi } from "../../app/slices/proposalSlice";
import { Box, IconButton, LinearProgress } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { Tooltip } from "@mui/material";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI


export default function Proposal() {
  const dispatch = useDispatch();

  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(proposalApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector((state) => state.proposal.proposal.data);
  const stateLoading = useSelector(
    (state) => state.proposal.loading
  );

  // loading={stateLoading}
  const columnHelper = createMRTColumnHelper();
  const columns = [
    // Identifying Information
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("client_id", {
      header: "Client ID",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.client_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.client_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.clientName}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id);
          toast.success("copied to clipboard!");
        };
        return (
          <>
            <Tooltip title={cell.row.original?.partner_id}>
              <span>
                <IconButton onClick={handleCopy}>
                  <ContentCopy />
                </IconButton>
                {cell.row.original?.partnerName}
              </span>
            </Tooltip>
          </>
        );
      },
    }),

    // Basic Transaction Details
    columnHelper.accessor("blockId", {
      header: "Block ID",
      size: 30,
      Cell: (cell) => cell.row.original?.blockId,
    }),
    columnHelper.accessor("proposal_no", {
      header: "Proposal No",
      size: 30,
      Cell: (cell) => cell.row.original?.proposal_no,
    }),
    columnHelper.accessor("order_type", {
      header: "Order Type",
      size: 30,
      Cell: (cell) => cell.row.original?.order_type,
    }),
    columnHelper.accessor("metal_type", {
      header: "Metal Type",
      size: 30,
      Cell: (cell) => cell.row.original?.metal_type,
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: (cell) => cell.row.original?.quantity,
    }),

    // Price Information
    columnHelper.accessor("amount", {
      header: "Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.amount,
    }),
    columnHelper.accessor("Price", {
      header: "Price",
      size: 30,
      Cell: (cell) => cell.row.original?.Price,
    }),
    columnHelper.accessor("gBuy", {
      header: "Gold Buy Price",
      size: 30,
      Cell: (cell) => cell.row.original?.gBuy,
    }),
    columnHelper.accessor("gSell", {
      header: "Gold Sell Price",
      size: 30,
      Cell: (cell) => cell.row.original?.gSell,
    }),
    columnHelper.accessor("sBuy", {
      header: "Silver Buy Price",
      size: 30,
      Cell: (cell) => cell.row.original?.sBuy,
    }),
    columnHelper.accessor("sSell", {
      header: "Silver Sell Price",
      size: 30,
      Cell: (cell) => cell.row.original?.sSell,
    }),

    // GST and Tax Details
    // columnHelper.accessor("cgsstType", {
    //   header: "CGSST Type",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.cgsstType,
    // }),
    // columnHelper.accessor("cgssttexPerc", {
    //   header: "CGSST Tax %",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.cgssttexPerc,
    // }),
    // columnHelper.accessor("sgstType", {
    //   header: "SGST Type",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.sgstType,
    // }),
    // columnHelper.accessor("sgsttexPerc", {
    //   header: "SGST Tax %",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.sgsttexPerc,
    // }),
    // columnHelper.accessor("igstType", {
    //   header: "IGST Type",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.igstType,
    // }),
    // columnHelper.accessor("igsttexPerc", {
    //   header: "IGST Tax %",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.igsttexPerc,
    // }),

    // GST Amounts
    columnHelper.accessor("gBuyGst", {
      header: "Gold Buy GST",
      size: 30,
      Cell: (cell) => cell.row.original?.gBuyGst,
    }),
    columnHelper.accessor("sBuyGst", {
      header: "Silver Buy GST",
      size: 30,
      Cell: (cell) => cell.row.original?.sBuyGst,
    }),

    // User and Partner Information
    columnHelper.accessor("clientName", {
      header: "Client Name",
      size: 30,
      Cell: (cell) => cell.row.original?.clientName,
    }),
    columnHelper.accessor("partnerName", {
      header: "Partner Name",
      size: 30,
      Cell: (cell) => cell.row.original?.partnerName,
    }),

    // Status
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: (cell) => cell.row.original?.status,
    }),

    // Timestamps
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),
  ];

  return (
    <>
     {/*  */}
      <>
        <DateSearchComponent onSearch={handleSearch} />
        <Box mt={2} >
          <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} permissionKey="Proposals" />
        </Box>
      </>

    </>
  );
}
